(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_mixins/relation"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_mixins/relation"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.relation);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _relation) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        class: ['fos-radio-group', _vm.direction === 'vertical' ? 'fos-radio-group_vertical' : '', _vm.border && _vm.direction === 'vertical' ? 'is-border' : ''],
        attrs: {
          "role": "group"
        }
      }, [_vm._t("default")], 2);
    },
    name: 'fos-radio-group',
    mixins: [(0, _relation.ParentMixin)('fosRadioParent')],
    props: {
      value: null,
      disabled: Boolean,
      direction: {
        type: String,
        default: 'vertical' // horizontal

      },
      border: {
        type: Boolean,
        default: true
      },
      stackDark: Boolean
    },
    watch: {
      value: function value(_value) {
        this.$emit('change', _value);
      }
    }
  };
  _exports.default = _default;
});